import React, { FC } from 'react';
import useSetupKeepState from '../../global/hooks/useSetupKeepState';
import WarehouseMainContent from './components/WarehouseMainContent/WarehouseMainContent';

const Warehouse: FC = () => {
  const key = useSetupKeepState();
  if (key === 'replaceState') {
    return null;
  }
  return <WarehouseMainContent key={key} />;
};

export default Warehouse;
